import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import * as React from "react";
// import { common_axios } from "../../../..";

// import { toast, ToastContainer } from "react-toastify";

// import ColumnFilter from "./ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableViewIcon from "@mui/icons-material/TableView";
import SearchIcon from "@mui/icons-material/Search";
import {
  Autocomplete,
  Backdrop,
  FormControl,
  InputLabel,
  MenuItem,
  Popover,
  Select,
  TextField,
  ThemeProvider,
  Typography,
} from "@mui/material";
// import Loader from "../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
// import defaulkt from "../../../../assets/images/altruist.webp";
// import Togglebar from "../../UserManagement/Tooglebar";
import Zoom from "react-medium-image-zoom";
import { Link } from "react-router-dom";
import { Option } from "antd/lib/mentions";

import Dialog from "@mui/material/Dialog";
import DialogActions, {
  dialogActionsClasses,
} from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PersonIcon from "@mui/icons-material/Person";
import Slide from "@mui/material/Slide";
import MailIcon from "@mui/icons-material/Mail";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import Person4Icon from "@mui/icons-material/Person4";
import EditIcon from "@mui/icons-material/Edit";
import { createTheme } from "@mui/material/styles";
import { useFormik } from "formik";

import CancelIcon from "@mui/icons-material/Cancel";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import Loader from "../../../components/Loader";
import { common_axios } from "../../../App";
import SmsDataTable from "./SmsDataTable";

export default function ChannelManagement() {
  const [open, setOpen] = useState(false);

  const [count, setcount] = useState(0);
  const [age, setAge] = React.useState("");
  const [agee, setAgee] = React.useState("");
  const [searchStatus, setSearchStatus] = useState(false);
  const [searchIcon, setSearchIcon] = useState(false);
  const [searchBar, setSearchBar] = useState(false);
  const [response, setResponse] = useState(2);
  const [mediumIdSelect, setmediumIdSelect] = useState(2);

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const handleChangee = (event) => {
    setAgee(event.target.value);
  };

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  const [roleTypes, setRoleTypes] = useState("");
  const [search, setSearch] = useState({
    role: null,
    userName: "",
    msisdn: "",
    status: null,
  });
  const [openTextfield, setOpenTextField] = useState({});

  const [approvedCount, setapprovedCount] = useState(0);
  const [rejectedCount, setrejectedCount] = useState(0);
  const [blockedCount, setBlockedCount] = useState(0);
  const [badgestatus, setbadgestatus] = useState(false);
  const [data, setData] = useState([
    {
      S_NO: "",
      // uid: "",
      username: "",
      // userRoleId: "",
      email: "",
      action: "",
      roleName: "",
      status: "",
    },
  ]);
  const customId1 = "custom-id-yess";
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [selectVerifyDocuments, setSelectVerifyDocuments] = useState(undefined);
  const [selectUnblockDetails, setSelectUnblockDetails] = useState(undefined);
  const [selectUserDetailsBlock, setSelectUserDetailsBlock] =
    useState(undefined);
  const [pendingCount, setpendingCount] = useState(0);
  const [Status, setStatus] = useState({
    tab: 1,
  });

  const [id, setId] = useState("");
  const [rejectedReasonValues, setRejectedReasonValues] = useState(undefined);
  const [approveValues, setApproveValues] = useState(undefined);
  const [anchorEl, setAnchorEl] = useState(null);

  const roleType = JSON.parse(localStorage.getItem("Sidebaritems"));

  console.log({ rejectedReasonValues });

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open1 = Boolean(anchorEl);

  const formik = useFormik({
    initialValues: {
      userName: "",
      msisdn: "",
    },

    validateOnChange: true,
  });

  const MediumIdResponse = (e) => setmediumIdSelect(e.target.value);
  const modalAddUser = useRef(null);
  const modalAddUserClose = useRef(null);
  const fetchUser = async () => {
    setOpen(true);
    try {
      console.log("kkk", Status.tab);
      const res = await common_axios(
        `http://192.168.167.66:5050/admin/v1/admin/channel/status?channelStatus=${Status.tab}&mediumId=${mediumIdSelect}`
      );
      console.log("appp", res.data);

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setcount(res.data.count);
        // console.log("eee", res.data.channelList.length);
        // setpendingCount(res?.data?.channelList.length);

        // setrejectedCount(res.data.channelList.length);

        // setData(res.data.userStatus);

        setData(res.data.channelList);
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went Wrong !! Please Check Your Network", {
        theme: "colored",
        toastId: customId1,
      });
    }

    // const res = await common_axios(
    //   `admin/v1/reseller/fetch/user-status/?userStatus=approved`
    // );
  };

  const getCountApi = async () => {
    const res = await common_axios(
      `http://192.168.167.66:5050/admin/v1/admin/channel/status/count/?mediumId=${mediumIdSelect}`
    );

    if (res.data.statusDescription.statusCode == 200) {
      // alert("count");
      setpendingCount(res.data.channelStatusList[0]?.count);
      setapprovedCount(res.data.channelStatusList[1]?.count);
      setrejectedCount(res.data.channelStatusList[2]?.count);
      // setBlockedCount(res.data.channelStatusList[3].count);
    }
    // console.log(res.data.channelList);
  };
  useEffect(async () => {
    await fetchUser();
    await getCountApi();
  }, [Status?.tab, mediumIdSelect]);

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonRejectClose = useRef();
  const modelButtonApprove = useRef(null);
  const modelVerifyDocuments = useRef(null);
  const modelEditUser = useRef(null);
  const modelblockedUser = useRef(null);
  const verifyDetails = useRef(null);
  const unblockUser = useRef(null);
  const modelCloseUnlock = useRef(null);

  const addReseller = useRef(null);
  const closeAddReseller = useRef(null);

  const addResellerModal = async (cell) => {
    await setSelectedUserDetailApprove(cell.row.original);
    await addReseller?.current?.click();
  };

  const rejectUserModal = async (cell) => {
    await setRejectedReasonValues(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };
  const approveUserModal = async (cell) => {
    await setSelectedUserDetail(cell.row.original);
    await modelButtonApprove?.current?.click();
  };
  // const unblockUserModal = async (cell) => {
  //   // console.log(cell.row.original);
  //   await setSelectUnblockDetails(cell?.row?.original);
  //   await unblockUser?.current?.click();
  // };
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        Footer: "name",
        accessor: "name",
      },
      {
        Header: "Price",
        Footer: "price",
        accessor: "price", // accessor is the "key" in the data
      },
      {
        Header: "Volume",
        Footer: "volume",
        accessor: "volume",
      },
      {
        Header: "Validity",
        Footer: "validity",
        accessor: "validity",
      },
      {
        Header: "Status",
        Footer: "Status",
        accessor: "response",
        Cell: (cell) => (
          <div className="">
            <button
              className="btn color_1  "
              type="button"
              id="dropdownMenuButton1"
              aria-expanded="false"
            >
              {console.log("aaa", cell.row.original.approved)}
              {cell.row.original.approved == 1 ? (
                <>
                  <span class="badge bg-success activated_1">success</span>
                </>
              ) : cell.row.original.approved == 0 ? (
                <>
                  <span class="badge bg-warning activated_1">Pending</span>
                </>
              ) : (
                <>
                  <span class="badge bg-danger activated_1">Rejected</span>
                </>
              )}

              {/* <DeleteIcon /> */}
            </button>
          </div>
        ),
      },

      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => {
          console.log({ cell });
          return (
            <div className="dropdown">
              <button
                className="btn color_1 dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="material-icons opacity-10 size">person</i>
              </button>
              {console.log("celldata", cell.row.original.status)}
              {cell.row.original.approved == 0 ? (
                <>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li
                      onClick={() => {
                        console.log(cell, "hello");
                      }}
                    >
                      <a
                        className="dropdown-item "
                        onClick={() => {
                          rejectUserModal(cell);
                        }}
                      >
                        <i class="fa fa-ban me-2" aria-hidden="true"></i>
                        Reject Channel
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserModal(cell);
                        }}
                      >
                        <i class="fa fa-thumbs-up me-2" aria-hidden="true"></i>
                        Approve User
                      </a>
                    </li>
                  </ul>
                </>
              ) : cell.row.original.approved == 2 ? (
                <>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li className="dropdown-item">
                      <a
                        className="dropdown-item "
                        onClick={() => {
                          addResellerModal(cell);
                        }}
                      >
                        <i class="fa fa-ban me-2" aria-hidden="true"></i>
                        View Details
                      </a>
                    </li>
                  </ul>
                </>
              ) : (
                <>
                  {" "}
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li className="dropdown-item">
                      <Link to="/kk">View Detai</Link>
                    </li>
                  </ul>
                </>
              )}
            </div>
          );
        },

        disableFilters: true,
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    console.log({ selectedFlatRows });
  };

  const approveUserApi = async (cell) => {
    try {
      setOpen(true);
      modelClose?.current?.click();
      const res = await common_axios.post(
        `http://192.168.167.66:5050/admin/v1/admin/channel/approve/action`,
        {
          channelId: approveValues.id,
          action: "approve",
          userId: Number(localStorage.getItem("UserId")),
        }
      );
      console.log("qq", res);
      console.log("approve", { cell });
      if (res.data.statusDescription.statusCode == 200) {
        setbadgestatus(true);
        // sethidebutton(false);
        fetchUser();
        setOpen(false);
        modelClose?.current?.click();
        // await setStatus("pending");
        await toast.success("Channel Approved", {
          theme: "colored",
          toastId: customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
          toastId: customId1,
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
        toastId: customId1,
      });
    }
  };
  const rejectChannelapi = async (e, cell) => {
    e.preventDefault();

    try {
      setOpen(true);

      const res = await common_axios.post(
        `http://192.168.167.66:5050/admin/v1/admin/channel/approve/action`,
        {
          action: "reject",
          // channelId: 8,
          channelId: rejectedReasonValues?.id,

          userId: Number(localStorage.getItem("UserId")),
          reason:
            selectedUserDetail.rejectedReason == "Other"
              ? selectedUserDetail.rejectedReasonText
              : selectedUserDetail.rejectedReason,
        }
      );
      console.log("rrr", cell);
      if (res.data.statusDescription.statusCode == 200) {
        // await modalAddUser?.current?.click();
        await modelButtonRejectClose?.current?.click();
        // fetchUser();
        setOpen(false);
        // await setStatus("approved");
        await toast.success("User has been rejected", {
          theme: "colored",
          // toastId: customId1,
          // toastId: customId1,
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
          // toastId: /,
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
        // toastId: customId1,
        // toastId: customId1,
      });
    }
  };
  // console.log("zz", rejectedReasonValues);
  console.log("zz", approveValues);
  const modelOpen = useRef();
  const modelClose1 = useRef();
  const modelClose = useRef();

  const textfiledRef = useRef(null);

  const textfieldClick = async () => {
    await textfiledRef.current.click();
  };

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  console.log({ selectVerifyDocuments });
  console.log({ selectedUserDetail });
  return (
    <main
      className="main-content pos_stat position-relative max-height-vh-100 h-100 border-radius-lg p-4"
      style={{ width: "auto", position: "static" }}
    >
      <div
        className="home-section home_section p-0"
        style={{ background: "none" }}
      >
        {selectedUserDetail != undefined && (
          <div>
            <button
              ref={modelButtonReject}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop1"
            >
              Launch static backdrop modal
            </button>
            <form onSubmit={rejectChannelapi}>
              <div
                className="modal fade"
                id="staticBackdrop1"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdrop1Label"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="staticBackdrop1Label">
                        User Rejection
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>

                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-6">
                          <label className="fw-bold mt-3 w-100">
                            Reason for Rejection :
                            <select
                              required
                              className="form-select mt-2"
                              name="reason"
                              id="reason"
                              onChange={(e) => {
                                if (e.target.value == "Other") {
                                  selectedUserDetail.rejectedReasonText = "";
                                }
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  rejectedReason: e.target.value,
                                });
                              }}
                            >
                              <label
                                id="reason"
                                name="reason"
                                selected="true"
                                hidden
                                disabled
                              >
                                Please Select
                              </label>
                              <option value="Incorrect User Information">
                                Incorrect User Information
                              </option>
                              <option value="Not Valid Pack">
                                Not Valid Pack
                              </option>
                              <option value="Incorrect ">Incorrect</option>

                              <option value="Other">Other</option>
                            </select>
                            {selectedUserDetail.rejectedReason == "Other" && (
                              <input
                                required
                                className="form-control mt-2"
                                placeholder="Rejected Reason Here"
                                type="text"
                                value={selectedUserDetail.rejectedReasonText}
                                onChange={(e) => {
                                  setSelectedUserDetail({
                                    ...selectedUserDetail,
                                    rejectedReasonText: e.target.value,
                                  });
                                }}
                              />
                            )}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        ref={modelButtonRejectClose}
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        // disabled={
                        //   selectedUserDetail.rejectedReason == "Other" ||
                        //   selectedUserDetail.rejectedReason
                        // }
                        // data-bs-dismiss="modal"
                      >
                        Reject User
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}

        {selectedUserDetailApprove != undefined && (
          <>
            <div>
              <button
                ref={addReseller}
                type="button"
                className="btn btn-primary d-none"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop10"
              >
                Launch static backdrop modal
              </button>
              {/* <form onSubmit={approveUserApi}> */}
              <div
                className="modal fade"
                id="staticBackdrop10"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdrop1Label"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="staticBackdrop1Label">
                        Details
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>

                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Name :
                          </label>
                          <input
                            disabled
                            required
                            className="form-control"
                            placeholder="Sender Id Here"
                            type="text"
                            minLength="3"
                            value={selectedUserDetailApprove?.name}
                          />
                        </div>
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Price :
                          </label>
                          <input
                            disabled
                            required
                            className="form-control"
                            placeholder="Sender Id Here"
                            type="text"
                            minLength="3"
                            value={selectedUserDetailApprove?.price}
                          />
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Volume :
                          </label>
                          <input
                            disabled
                            required
                            className="form-control"
                            placeholder="Sender Id Here"
                            type="text"
                            minLength="3"
                            value={selectedUserDetailApprove?.volume}
                          />
                        </div>
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Validity :
                          </label>
                          <input
                            disabled
                            required
                            className="form-control"
                            placeholder="Sender Id Here"
                            type="text"
                            minLength="3"
                            value={selectedUserDetailApprove?.validity}
                          />
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        // ref={modelButtonRejectClose}
                        type="submit"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* </form> */}
            </div>
          </>
        )}

        {/* {selectedUserDetailApprove != undefined && selectVerifyDocuments != undefined && ( */}
        <>
          <div>
            <button
              ref={modelButtonApprove}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop7"
            >
              Launch static backdrop modal
            </button>

            <div
              class="modal fade"
              id="staticBackdrop7"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      User Approval?
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <from onSubmit={approveUserApi}>
                    <div className="modal-body">
                      <button
                        // ref={modelButtonRejectClose}
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          approveUserApi();
                        }}
                      >
                        Approve User
                      </button>
                    </div>
                    <div class="modal-footer">
                      <h6
                        // ref={modelButtonRejectClose}
                        type="submit"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                      ></h6>
                    </div>
                  </from>
                </div>
              </div>
            </div>
          </div>
        </>
        <div className="container-fluid">
          <Backdrop
            sx={{
              transform: "translateZ(0)",
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
          <ToastContainer autoClose={6000} />
          <div class="card mb-3 mt-4">
            <div class="card-header p-3 pt-2">
              <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                <i class="material-icons opacity-10">person</i>
                {/* <div>User Management</div> */}
              </div>
              <div
                class="d-flex justify-content-between pt-1"
                style={{ marginLeft: "76px" }}
              >
                <div className="fw-bold">Channel Verification</div>
              </div>
            </div>
            <div className="col mt-auto ">
              <div className="col-md-2 btn  w_btn m-0 me-4">
                <FormControl required fullWidth size="small">
                  <InputLabel id="demo-simple-select-autowidth-label">
                    Medium
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={mediumIdSelect}
                    onChange={MediumIdResponse}
                    // autowidth
                    label="Medium"
                  >
                    <MenuItem value={2}>Data</MenuItem>
                    <MenuItem value={3}>SMS</MenuItem>
                    {/* <MenuItem value="false">OBD</MenuItem>
                                  <MenuItem value="false">SMS Insert</MenuItem> */}
                  </Select>
                </FormControl>
              </div>
            </div>
            {mediumIdSelect == 2 ? (
              <div class="card-body">
                <ul class="nav nav-tabs mt-2 " id="myTab" role="tablist">
                  <li class="nav-item ms-4" role="presentation">
                    <button
                      class="nav-link position-relative"
                      id="home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#AccountDetails"
                      type="button"
                      role="tab"
                      // value={0}
                      aria-controls="AccountDetails"
                      aria-selected="true"
                      onClick={(e) => {
                        setStatus({
                          ...Status,
                          tab: 0,
                        });
                      }}
                    >
                      <span class="position-absolute spn_8 top-0 start-100 translate-middle badge rounded-pill bg-warning">
                        {pendingCount}
                        <span class="visually-hidden">unread messages</span>
                      </span>
                      Pending
                    </button>
                  </li>

                  <li class="nav-item ms-4" role="presentation">
                    <button
                      class="nav-link position-relative"
                      id="SenderMasking-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#SenderMasking"
                      type="button"
                      role="tab"
                      aria-controls="SenderMasking"
                      aria-selected="false"
                      onClick={(e) => {
                        setStatus({
                          ...Status,
                          tab: 2,
                        });
                      }}
                    >
                      <span class="position-absolute spn_8 top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        {rejectedCount}
                        <span class="visually-hidden">unread messages</span>
                      </span>
                      Rejected
                    </button>
                  </li>
                  <li class="nav-item ms-4" role="presentation">
                    <button
                      class="nav-link position-relative"
                      id="SenderMasking-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#SenderMasking"
                      type="button"
                      role="tab"
                      aria-controls="SenderMasking"
                      aria-selected="false"
                      onClick={(e) => {
                        setStatus({
                          ...Status,
                          tab: 1,
                        });
                      }}
                    >
                      <span class="position-absolute spn_8 top-0 start-100 translate-middle badge rounded-pill bg-success">
                        {approvedCount}
                        <span class="visually-hidden">unread messages</span>
                      </span>
                      Approved
                    </button>
                  </li>

                  {/* <div className="col">
    <label>Show All :-</label>
    <div>
      <input type="radio" id="huey" name="drone" value="huey" />
      <label for="huey">Admin</label>
    </div>

    <div>
      <input type="radio" id="dewey" name="drone" value="dewey" />
      <label for="dewey">Users</label>
    </div>

    <div>
      <input type="radio" id="louie" name="drone" value="louie" />
      <label for="louie">Resellers</label>
    </div>
  </div> */}
                </ul>

                <div>
                  {/* <div>
    <Checkbox {...getToggleHideAllColumnsProps()} /> Toggle All
    Columns
  </div> */}
                  <div></div>
                </div>
                {/* <div class="dropdown">
  <button
    class="btn bg-gradient-primary dropdown-toggle mt-3"
    type="button"
    id="dropdownMenuButton"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    onChange={(e) => setStatus(e.target.value)}
  >
    Status
  </button>
  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
    <li>
      <a
        class="dropdown-item"
        value="pending"
        onClick={() => {
          setStatus("allUser");
        }}
      >
        All Users
      </a>
    </li>
    <li>
      <a
        class="dropdown-item"
        value="pending"
        onClick={() => {
          setStatus("pending");
        }}
      >
        Pending
      </a>
    </li>
    <li>
      <a
        class="dropdown-item"
        value="approved"
        //   onChange={(e) => setStatus(e.target.value)}
        onClick={() => {
          setStatus("approved");
        }}
      >
        Approveds
      </a>
    </li>
    <li>
      <a
        class="dropdown-item"
        value="rejected"
        onClick={() => {
          setStatus("rejected");
        }}
      >
        Rejected
      </a>
    </li>
  </ul>
</div> */}

                <div className="text-end mt-2 mb-2">
                  {/* {searchBar == false && (
                    <button
                      onClick={() => {
                        setSearchIcon(true);
                        setSearchBar(true);
                      }}
                    >
                      <SearchIcon />
                    </button>
                  )} */}

                  {/* {searchBar == true && (
                    <button
                      onClick={() => {
                        setSearchIcon(false);
                        setSearchBar(false);
                      }}
                    >
                      <CancelIcon />
                    </button>
                  )} */}
                </div>

                <div className="d-flex justify-content-between my-3">
                  <select
                    value={pageSize}
                    className="dropdown"
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                    }}
                  >
                    {[10, 25, 50].map((value, i) => {
                      return (
                        <option
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                          value={value}
                          key={value}
                        >
                          {" "}
                          Show {value}
                        </option>
                      );
                    })}
                  </select>

                  <div>
                    {/* {allColumns.map((column) => {
      return (
        <div key={column.id}>
          <label>
            <input
              type="checkbox"
              {...column.getToggleHiddenProps()}
            />
            {column.Header}
          </label>
        </div>
      );
    })} */}
                  </div>
                  <TextField
                    className="ms-4 "
                    style={{
                      borderRadius: "4px",
                    }}
                    type="text"
                    label="Search"
                    name="Search"
                    variant="outlined"
                    // value={number}
                    size="small"
                    value={globalSearchValue || ""}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setGlobalSearchValue(e.target.value);
                    }}
                  />
                </div>

                <div className="text-end">
                  {selectedFlatRows.length > 0 && (
                    <button
                      onClick={deletUser}
                      className="btn bg-gradient-primary m-0"
                    >
                      Delete Users
                    </button>
                  )}

                  {/* <button onClick={changeOrder}>Change Order</button> */}
                </div>

                <div className="table-responsive">
                  <table
                    {...getTableProps()}
                    id="example"
                    className="table table-striped table-bordered dataTable table-sm mt-3 table-responsive"
                    // className=" table table-responsive table-striped table-bordered dataTable mt-3"
                  >
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                              className="text-left width_2"
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? "↑"
                                    : "↓"
                                  : ""}
                              </span>

                              {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  className="text-left"
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between align-items-center my-3">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {pageIndex + 1} of {pageOptions.length}
                      </strong>
                    </span>

                    <span>
                      | Go to Page :{""}
                      <input
                        type="number"
                        defaultValue={pageIndex + 1}
                        onChange={(e) => {
                          const pageNumber = e.target.value
                            ? Number(e.target.value) - 1
                            : 0;
                          gotoPage(pageNumber);
                        }}
                        style={{ width: "50px" }}
                      />
                    </span>
                  </div>

                  <div id="nikhil">
                    <button
                      className="btn btn_primary m-0"
                      type="button"
                      disabled={!canPreviousPage}
                      onClick={() => {
                        previousPage();
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary m-0 ms-2"
                      type="button"
                      disabled={!canNextPage}
                      onClick={() => {
                        nextPage();
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
                <div className="text-end mt-2">
                  <p> Want to Add Medium </p>
                  <Link
                    to="/dashboard/main-master"
                    style={{ color: "#63B7E6", marginLeft: "30px" }}
                  >
                    <span>Click here !!!</span>
                  </Link>
                </div>
              </div>
            ) : (
              <SmsDataTable />
            )}
          </div>{" "}
        </div>
        {/* <pre>
        <code>
          {JSON.stringify(
            {
              selectFlatRows: selectedFlatRows.map((row) => row.original),
            },
            null,
            2
          )}
        </code>
      </pre> */}
      </div>{" "}
    </main>
  );
}
